import React, { useRef, useEffect, useState } from 'react'
import ProductFilter from './ProductFilter'
import { CommonHeadFooter, ProdCardDesc, ProdCardName, ProductListingTitle, OriginalPrice } from '../../../StyledComponents';
import {
  Col, Row, Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';
import offer1 from '../../../assets/images/dummyImages/offer1.jpg'
import tshirt from '../../../assets/images/dummyImages/t-shirt-1.jpg'
import refresh from '../../../assets/images/productListing/refresh.svg'
import grid from '../../../assets/images/productListing/grid.svg'
import rows from '../../../assets/images/productListing/rows.svg'
import { Star } from 'react-feather';
import GridProducts from './GridProducts';
import RowProducts from './RowProducts';
import PaginationComponent from '../../Manage/PaginationComponent';
import PopupModal from '../../Manage/PopupModal';
import PreFooter from '../../../@core/layouts/components/landing/PreFooter';
import { API_URLS } from '../../../utility/api/endpoints/endpoints';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProductListing = () => {

  const [modal, setModal] = useState(false);
  const [productRelevantCategories, setProductRelevantCategories] = useState()

  const { filteredProducts } = useSelector(state => state.product)
  // Automatically open the modal after 3 seconds
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setModal(true); // Open modal after 3 seconds
  //   }, 3000);

  //   // Cleanup the timeout if the component unmounts
  //   return () => clearTimeout(timer);
  // }, []);


  const location = useLocation()

  const categoryId = location?.state?.categoryId
  const categoryName = location?.state?.categoryName

  const handleModal = () => setModal(!modal);

  const categories = [
    {
      title: "T-shirts/Tops",
      imageUrl: "https://picsum.photos/300/200"
    },
    {
      title: "Pants",
      imageUrl: "https://picsum.photos/300/200"
    },
    {
      title: "Sports",
      imageUrl: "https://picsum.photos/300/200"
    },
    {
      title: "Fashion",
      imageUrl: "https://picsum.photos/300/200"
    },
    {
      title: "Sports",
      imageUrl: "https://picsum.photos/300/200"
    },
    {
      title: "Fashion",
      imageUrl: "https://picsum.photos/300/200"
    },

  ];

  const products = [
    {
      id: 1,
      name: "Name of product will be here",
      price: 33.99,
      originalPrice: 49.99,
      rating: 5.0,
      reviews: 300,
      image: tshirt,
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
    },
    {
      id: 2,
      name: "Another product name",
      price: 29.99,
      originalPrice: 39.99,
      rating: 4.5,
      reviews: 250,
      image: tshirt,
      description: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo."
    },
    {
      id: 3,
      name: "Stylish T-shirt",
      price: 19.99,
      originalPrice: 24.99,
      rating: 4.2,
      reviews: 180,
      image: tshirt,
      description: "A stylish t-shirt that fits perfectly for all occasions, available in multiple colors."
    },
    {
      id: 4,
      name: "Cool Hoodie",
      price: 49.99,
      originalPrice: 59.99,
      rating: 4.7,
      reviews: 120,
      image: tshirt,
      description: "Stay warm and stylish with this cool hoodie, made from high-quality fabric."
    },
    {
      id: 5,
      name: "Casual Sneakers",
      price: 59.99,
      originalPrice: 79.99,
      rating: 4.9,
      reviews: 400,
      image: tshirt,
      description: "Comfortable and trendy sneakers, perfect for everyday use and sports activities."
    },
    {
      id: 6,
      name: "Name of product will be here",
      price: 33.99,
      originalPrice: 49.99,
      rating: 5.0,
      reviews: 300,
      image: tshirt,
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
    },
    {
      id: 7,
      name: "Another product name",
      price: 29.99,
      originalPrice: 39.99,
      rating: 4.5,
      reviews: 250,
      image: tshirt,
      description: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo."
    },
    {
      id: 8,
      name: "Stylish T-shirt",
      price: 19.99,
      originalPrice: 24.99,
      rating: 4.2,
      reviews: 180,
      image: tshirt,
      description: "A stylish t-shirt that fits perfectly for all occasions, available in multiple colors."
    },
    {
      id: 9,
      name: "Cool Hoodie",
      price: 49.99,
      originalPrice: 59.99,
      rating: 4.7,
      reviews: 120,
      image: tshirt,
      description: "Stay warm and stylish with this cool hoodie, made from high-quality fabric."
    },
    {
      id: 10,
      name: "Casual Sneakers",
      price: 59.99,
      originalPrice: 79.99,
      rating: 4.9,
      reviews: 400,
      image: tshirt,
      description: "Comfortable and trendy sneakers, perfect for everyday use and sports activities."
    },
    {
      id: 11,
      name: "Name of product will be here",
      price: 33.99,
      originalPrice: 49.99,
      rating: 5.0,
      reviews: 300,
      image: tshirt,
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
    },
    {
      id: 12,
      name: "Another product name",
      price: 29.99,
      originalPrice: 39.99,
      rating: 4.5,
      reviews: 250,
      image: tshirt,
      description: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo."
    },
    {
      id: 13,
      name: "Stylish T-shirt",
      price: 19.99,
      originalPrice: 24.99,
      rating: 4.2,
      reviews: 180,
      image: tshirt,
      description: "A stylish t-shirt that fits perfectly for all occasions, available in multiple colors."
    },
    {
      id: 14,
      name: "Cool Hoodie",
      price: 49.99,
      originalPrice: 59.99,
      rating: 4.7,
      reviews: 120,
      image: tshirt,
      description: "Stay warm and stylish with this cool hoodie, made from high-quality fabric."
    },
    {
      id: 15,
      name: "Casual Sneakers",
      price: 59.99,
      originalPrice: 79.99,
      rating: 4.9,
      reviews: 400,
      image: tshirt,
      description: "Comfortable and trendy sneakers, perfect for everyday use and sports activities."
    },
  ];


  const [currentItems, setCurrentItems] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(3);

  // Get the view from localStorage or default to 'grid'
  const [view, setView] = useState(() => {
    return localStorage.getItem('view') || 'grid';
  });
  const [productsPerRow, setProductsPerRow] = useState(4); // default for large screens



  // const handlePageChange = (page, perPage = itemsPerPage) => {
  //   const startIndex = (page - 1) * perPage;
  //   const endIndex = startIndex + perPage;
  //   setCurrentItems(products.slice(startIndex, endIndex));
  // };


  const handlePageChange = (page, perPage = itemsPerPage) => {
    // Check if the view is "grid" to calculate the grid-specific logic
    if (view === 'grid') {
      const startIndex = (page - 1) * perPage * productsPerRow;
      const endIndex = startIndex + (perPage * productsPerRow);
      setCurrentItems(products.slice(startIndex, endIndex));
    } else {
      const startIndex = (page - 1) * perPage;
      const endIndex = startIndex + perPage;
      setCurrentItems(products.slice(startIndex, endIndex));
    }
  };

  // const handleRowsPerPageChange = (newItemsPerPage) => {
  //   // Update the state for items per page
  //   setItemsPerPage(newItemsPerPage);
  //   // Calculate the items for the first page based on new items per page
  //   const newEndIndex = newItemsPerPage;
  //   setCurrentItems(products.slice(0, newEndIndex));
  //   // Reset the pagination to the first page
  //   handlePageChange(1, newItemsPerPage);
  // };

  const handleRowsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    handlePageChange(1, newItemsPerPage);
  };

  const updateProductsPerRow = () => {
    if (window.innerWidth >= 1200) {
      setProductsPerRow(4); // lg screen
    } else if (window.innerWidth >= 768) {
      setProductsPerRow(3); // md screen
    } else if (window.innerWidth >= 576) {
      setProductsPerRow(2); // sm screen
    } else {
      setProductsPerRow(1); // xs screen
    }
  };

  useEffect(() => {
    // Update the number of products per row only for Grid view
    if (view === 'grid') {
      updateProductsPerRow();
      window.addEventListener('resize', updateProductsPerRow);
    }
    return () => window.removeEventListener('resize', updateProductsPerRow);
  }, [view]);

  useEffect(() => {
    // Initialize first page of items
    handlePageChange(1);
  }, [productsPerRow, view]);



  const videoEl = useRef(null);

  const attemptPlay = () => {
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch(error => {
        console.error("Error attempting to play", error);
      });
  };

  useEffect(() => {
    attemptPlay();
  }, []);



  // Update localStorage whenever the view changes
  useEffect(() => {
    localStorage.setItem('view', view);
  }, [view]);

  const [isLoading, setIsLoading] = useState(true)

  const fetchProductRelevantCategories = async () => {
    try {
      const { data } = await axios.get(`${API_URLS.FETCH_RELEVANT_CATEGORIES}/${categoryId}`)
      if (data.statusCode === 200) {
        setProductRelevantCategories(data.data)
      } else {
        setProductRelevantCategories([])
      }
    }
    catch (error) {
      console.log("error fetching relevant categories: ", error);
    }
    finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchProductRelevantCategories()
  }, [])

  return (
    <>
      <div className='p-4 d-flex flex-row flex-nowrap align-items-top ' >
        <div style={{ width: '20%', marginRight: '35px' }}>
          <ProductFilter categoryId={categoryId} categoryName={categoryName} />

        </div>
        <div style={{ width: '80%', }}>
          <div style={{ width: '100%', borderBottom: '1px solid #F2F2F2', marginBottom: '1rem' }}>
            <ProductListingTitle>
              CATEGORIES
            </ProductListingTitle>
          </div>

          {isLoading ? (
            <div style={{ height: "8rem", alignContent: "center", textAlign: 'center' }}>Loading...</div>
          ) : (
            <>
              {/* {productRelevantCategories && productRelevantCategories.length > 0 ? ( */}
                <div className="d-flex flex-wrap justify-content-start w-100">
                  {categories.map((category, index) => (
                    <div key={index} className="text-center" style={{ marginRight: 'auto' }}>
                      <div className='item-img'>
                        <img
                          style={{ width: '163px', height: '102px' }}
                          src={category.imageUrl === null ? 'https://placehold.co/163?text=No+Image' : category.imageUrl}
                          alt={category.title}
                          className='img-fluid card-img-top'
                        />
                      </div>
                      <h5>{category.title}</h5>
                    </div>
                  ))}
                </div>
              {/* ) : (
                <div style={{ height: "8rem", alignContent: "center", textAlign: 'center' }}>
                  No relevant categories found.
                </div>
              )} */}
            </>
          )}

          <div >
            <div style={{ width: '100%', borderBottom: '1px solid #F2F2F2', marginBottom: '1rem' }}>
              <ProductListingTitle>
                LIVE OFFERS
              </ProductListingTitle>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }} >

              <div className='w-100'>
                <Row flex>
                  <Col lg='6' md='12' sm='12' xs='12'>
                    <img src={offer1} className='img-fluid card-img-top responsive' />
                  </Col>
                  <Col lg='6' md='12' sm='12' xs='12'>
                    <img src={offer1} className='img-fluid card-img-top responsive' />
                  </Col>
                </Row>

              </div>

            </div>
          </div>
          <div>
            <div style={{ width: '100%', borderBottom: '1px solid #F2F2F2', marginBottom: '1rem', marginTop: '27px' }}>
              <ProductListingTitle>
                PROMOTIONS
              </ProductListingTitle>
            </div>
            <div className='w-100'>
              <Row flex>
                <Col lg='3' md='4' sm='12' xs='12'>
                  <video
                    style={{ maxWidth: "100%", width: "800px", margin: "0 auto" }}
                    playsInline
                    loop
                    muted
                    alt="All the devices"
                    src="https://stream.mux.com/6fiGM5ChLz8T66ZZiuzk1KZuIKX8zJz00/medium.mp4"
                    ref={videoEl}
                  />
                </Col>
                <Col lg='3' md='4' sm='12' xs='12'>
                  <video
                    style={{ maxWidth: "100%", width: "800px", margin: "0 auto" }}
                    playsInline
                    loop
                    muted
                    alt="All the devices"
                    src="https://stream.mux.com/6fiGM5ChLz8T66ZZiuzk1KZuIKX8zJz00/medium.mp4"
                    ref={videoEl}
                  />
                </Col>
                <Col lg='3' md='4' sm='12' xs='12'>
                  <video
                    style={{ maxWidth: "100%", width: "800px", margin: "0 auto" }}
                    playsInline
                    loop
                    muted
                    alt="All the devices"
                    src="https://stream.mux.com/6fiGM5ChLz8T66ZZiuzk1KZuIKX8zJz00/medium.mp4"
                    ref={videoEl}
                  />
                </Col>
                <Col lg='3' md='4' sm='12' xs='12'>
                  <video
                    style={{ maxWidth: "100%", width: "800px", margin: "0 auto" }}
                    playsInline
                    loop
                    muted
                    alt="All the devices"
                    src="https://stream.mux.com/6fiGM5ChLz8T66ZZiuzk1KZuIKX8zJz00/medium.mp4"
                    ref={videoEl}
                  />
                </Col>
              </Row>

            </div>
          </div>

          <div>
            <div style={{ width: '100%', borderBottom: '1px solid #F2F2F2', marginBottom: '1rem', marginTop: '27px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap' }}>
              <ProductListingTitle style={{ backgroundColor: '#41B8E4' }}>
                RESULTS
              </ProductListingTitle>
              <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around', alignItems: 'center' }}>
                <div style={{ fontSize: '18px', fontWeight: '500', marginRight: '0.5rem' }}>
                  30,000 items found
                </div>
                <div style={{ marginRight: '0.5rem' }}>
                  <img src={refresh} />
                </div>
                <div style={{ marginRight: '0.5rem' }} onClick={() => setView('grid')}>
                  <img src={grid} />
                </div>
                <div style={{ marginRight: '0.5rem' }} onClick={() => setView('row')}>
                  <img src={rows} />
                </div>
              </div>
            </div>
            {/* Conditionally render Grid or Row view based on the 'view' state */}
            {view === 'grid' ? (
              <GridProducts products={currentItems} />
            ) : (
              <RowProducts products={currentItems} />
            )}
            <div>
              <PaginationComponent
                totalItems={products.length}
                siblingCount={2}  // Show 2 pages before and after the current page
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              />
            </div>
          </div>
        </div>

      </div>
      <PreFooter />

      <PopupModal
        company_id={''}
        open={modal}
        setModal={setModal}
        handleModal={handleModal}
        name={'Popup'}
        tableData={''}
        setTableData={''}
      />
    </>
  )
}

export default ProductListing